'use client';

import React, { memo, useMemo } from 'react';
import Image from 'next/image';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  /** Show only the icon mark (square crop) without the text portion */
  iconOnly?: boolean;
}

const AppLogo = memo(function AppLogo({
  size = 40,
  className = '',
  onClick,
  iconOnly = false,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  // The SVG viewBox is 500×500 but visually the mark+text fits a ~3:1 wide ratio
  const width = iconOnly ? size : Math.round(size * 2.8);
  const height = size;

  return (
    <div className={containerClassName} onClick={onClick}>
      <Image
        src="/assets/macro-capital-logo.svg"
        alt="Macro Capital logo"
        width={width}
        height={height}
        style={{ objectFit: 'contain' }}
        priority
      />
    </div>
  );
});

export default AppLogo;
